import React, { useEffect } from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'
import { trackSectionView } from '../utils/mixpanel';

function Timeline() {
  useEffect(() => {
    trackSectionView('history');
  }, []);

  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
        {/* <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2025 - Current"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Android Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Karachi , Pakistan</h4>
           
            <p>
              Smart System Integrations (Part Time)
            </p>
            <p>
             B2B App Development , Computer Vision , Tensor Flow , Machine Learning , Augumented Reality
            </p>
          </VerticalTimelineElement> */}
        <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2024 - Current"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Technical Team Lead (Mobile Apps)</h3>
            <h4 className="vertical-timeline-element-subtitle">Germany (Remote)</h4>
           
            <p>
              Echosoft Solutions
            </p>
            <p>
             Mobile Apps (Android & IOS) , Backend Development , Team Management , Client Meetings
            </p>
          </VerticalTimelineElement>
        <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2023 - 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Mobile Application Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">United Kingdom (Remote)</h4>
           
            <p>
              Hello Super App
            </p>
            <p>
              Super App , Backend Development , Product Development , Team Management , Client Meetings
            </p>
          </VerticalTimelineElement>
        <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2022 - 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Android Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">South Korea (Remote)</h4>
            <p>
              Kstyles
            </p>
            <p>
              Product Development, Research, Working with Apis, Unit Testing , Dependency Injection , Jetpack Compose
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2021 - 2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Android Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Lahore, Pakistan</h4>
           
            <p>
              Geeklone Technology
            </p>
            <p>
              Ai Driven Apps , Product Development , Team Management , Client Meetings
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2020 - 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Android Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Lahore, Pakistan</h4>
            <p>
              Ozi Technology
            </p>
            <p>
              Product Development, Research, Working with Apis, Unit Testing , Dependency Injection
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2019 - 2020"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Android Application Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Pakistan</h4>
            <p>
              Echosoft Solutions
            </p>
            <p>
              Android App Development, Trainings , User Experience
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2017 - 2019"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Android Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Pakistan</h4>
            <p>
              ByteSole
            </p>
            <p>
              Android App Development , Interns Trainings , Collaboration with backend developers
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;